// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./amplifyConfig";
import "./index.css";
// import 'antd/dist/reset.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Scrollbar edge selection guard
(() => {
  const SCROLLBAR_GUARD_PX = 14;

  const onMouseDown = (e) => {
    const xFromRight = window.innerWidth - e.clientX;

    if (xFromRight <= SCROLLBAR_GUARD_PX) {
      document.body.classList.add("disable-selection");
    }
  };

  const onMouseUp = () => {
    document.body.classList.remove("disable-selection");
  };

  document.addEventListener("mousedown", onMouseDown);
  document.addEventListener("mouseup", onMouseUp);
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
